var dd = require('react-dd');
var LoadingBar = require('./LoadingBar');

require('./LoadingWrap.less.js');

module.exports = dd.createClass({
	render: function(){
		var text = this.props.text;
		var glass = this.props.glass;
		var children = this.props.children;
		var is_loading = this.props.is_loading;

		//NOTE using lots of terinary operators on purpose. Why? so you don't unmount then remount the children frequently (causes forms to reset to the initial state when saving)
		return dd.div({className: 'LoadingWrap ' + (is_loading ? (glass ? 'relative' : 'text-center') : '')},

			is_loading && glass ? dd.div({className: 'waitGlass'},
				dd.div({className: 'circleG'},
					dd.div({className: 'circleG circleG_1'}),
					dd.div({ className: 'circleG circleG_2'}),
					dd.div({className: 'circleG circleG_3'})
				)
			) : null,

			is_loading && !glass ? null : children,

			is_loading && !glass ? dd.h4({}, this.props.text || 'Loading...') : null,
			is_loading && !glass ? LoadingBar() : null
		);
	}
});



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/LoadingWrap.js
// module id = 8
// module chunks = 0 1 2 3 4